module.exports = __webpack_public_path__ + "img/approve_icon.f166c8ae.png";